var map = {
	"./action-heart.svg": 21,
	"./area-badges/atmospheric-conditions.svg": 22,
	"./area-badges/biodiversity.svg": 23,
	"./area-badges/circular-economies.svg": 24,
	"./area-badges/clean-transport.svg": 25,
	"./area-badges/eat-better.svg": 26,
	"./area-badges/ecological-explorations.svg": 27,
	"./area-badges/food-security-production.svg": 28,
	"./area-badges/green-manufacturing.svg": 29,
	"./area-badges/health-wellness.svg": 30,
	"./area-badges/land-stewardship.svg": 31,
	"./area-badges/live-better.svg": 32,
	"./area-badges/make-better.svg": 33,
	"./area-badges/material-science.svg": 34,
	"./area-badges/move-better.svg": 35,
	"./area-badges/new-fuel-sources.svg": 36,
	"./area-badges/ocean-stewardship.svg": 37,
	"./area-badges/regenerative-ecosystems.svg": 38,
	"./area-badges/renewable-equitable-energy.svg": 39,
	"./area-badges/sustainable-cities-communities.svg": 40,
	"./area-badges/virtual-connections.svg": 41,
	"./badges/atmospheric-conditions-100.svg": 42,
	"./badges/biodiversity-100.svg": 43,
	"./badges/circular-economies-100.svg": 44,
	"./badges/clean-transport-100.svg": 45,
	"./badges/ecological-explorations-100.svg": 46,
	"./badges/food-security-production-100.svg": 47,
	"./badges/green-manufacturing-100.svg": 48,
	"./badges/health-wellness-100.svg": 49,
	"./badges/land-stewardship-100.svg": 50,
	"./badges/material-science-100.svg": 51,
	"./badges/new-fuel-sources-100.svg": 52,
	"./badges/ocean_stewardship-100.svg": 53,
	"./badges/regenerative-ecosystems-100.svg": 54,
	"./badges/renewable-energy-100.svg": 55,
	"./badges/sustainable-cities-communities-100.svg": 56,
	"./badges/virtual-connections-100.svg": 57,
	"./blob-bg.png": 58,
	"./carbon-emissions-bg.png": 59,
	"./check-new.svg": 60,
	"./close.svg": 61,
	"./default-profile-pic.svg": 62,
	"./edit-note.svg": 63,
	"./globe.png": 64,
	"./group-circle.png": 65,
	"./hamburger.svg": 66,
	"./heroes/eat.png": 67,
	"./heroes/home-2.png": 68,
	"./heroes/home-3.png": 69,
	"./heroes/home.png": 70,
	"./heroes/live.png": 71,
	"./heroes/make.png": 72,
	"./heroes/move.png": 73,
	"./heroes/norton.jpg": 74,
	"./home-banner.png": 75,
	"./logo.svg": 76,
	"./menu-icons/articles.svg": 77,
	"./menu-icons/eat.svg": 78,
	"./menu-icons/events.svg": 79,
	"./menu-icons/find-a-solution.svg": 80,
	"./menu-icons/live.svg": 81,
	"./menu-icons/make.svg": 82,
	"./menu-icons/move.svg": 83,
	"./menu-icons/my-progress.svg": 84,
	"./menu-icons/photos.svg": 85,
	"./menu-icons/shop-products.svg": 86,
	"./menu-icons/videos.svg": 87,
	"./mock-thumbs/article-1.png": 88,
	"./mock-thumbs/article-2.png": 89,
	"./mock-thumbs/article-3.png": 90,
	"./mock-thumbs/event-1.png": 91,
	"./mock-thumbs/event-2.png": 92,
	"./mock-thumbs/event-3.png": 93,
	"./mock-thumbs/palms-banner.png": 94,
	"./mock-thumbs/product-1.png": 95,
	"./mock-thumbs/product-2.png": 96,
	"./mock-thumbs/product-3.png": 97,
	"./mock-thumbs/un-champions-banner.png": 98,
	"./sleepy-time.svg": 99,
	"./social-icons/download.svg": 100,
	"./social-icons/email-white.svg": 101,
	"./social-icons/email.svg": 102,
	"./social-icons/facebook-white.svg": 103,
	"./social-icons/facebook.svg": 104,
	"./social-icons/instagram-white.svg": 105,
	"./social-icons/instagram.svg": 106,
	"./social-icons/link-white.svg": 107,
	"./social-icons/link.svg": 108,
	"./social-icons/linkedin-white.svg": 109,
	"./social-icons/linkedin.svg": 110,
	"./social-icons/pinterest-p.svg": 111,
	"./social-icons/pinterest-white.svg": 112,
	"./social-icons/pinterest.svg": 113,
	"./social-icons/twitter-white.svg": 114,
	"./social-icons/twitter.svg": 115,
	"./social-icons/vero-white.svg": 116,
	"./social-icons/vero.svg": 117,
	"./social-icons/youtube-white.svg": 118,
	"./social-icons/youtube.svg": 119,
	"./target-new.svg": 120,
	"./thank-you-bg.png": 121,
	"./water-reduction-bg.png": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;